import { render, staticRenderFns } from "./FocalPointPreviewFrame.vue?vue&type=template&id=a808fd44&"
import script from "./FocalPointPreviewFrame.vue?vue&type=script&lang=js&"
export * from "./FocalPointPreviewFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports